var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",attrs:{"id":"dig-report-detail-translate-cmp"}},[(_vm.message['分类']=='自定义分析')?[_c('CustomReportTransfer',{attrs:{"result":_vm.message.data}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }